var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "website",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7043",
    "data-name": "Rectangle 7043",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426",
    transform: "translate(-0.848 -0.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M12.848,23.7A10.848,10.848,0,1,0,2,12.848,10.857,10.857,0,0,0,12.848,23.7Zm-8.4-6.526,4.409-.035a15.7,15.7,0,0,0,2.432,5.021A9.461,9.461,0,0,1,4.449,17.169Zm5.529-7.3h5.494a14.843,14.843,0,0,1,.035,5.826l-5.529.035A14.379,14.379,0,0,1,9.978,9.873Zm2.747,11.88a14.044,14.044,0,0,1-2.4-4.619L15.14,17.1A14.782,14.782,0,0,1,12.725,21.753Zm1.4.455a15.427,15.427,0,0,0,2.467-5.126l4.706-.035A9.471,9.471,0,0,1,14.125,22.208Zm8.171-9.36a9.757,9.757,0,0,1-.42,2.8l-4.951.035a15.814,15.814,0,0,0-.035-5.809h4.916A9.3,9.3,0,0,1,22.3,12.848ZM21.211,8.474H16.557a16.089,16.089,0,0,0-2.432-4.986A9.407,9.407,0,0,1,21.211,8.474Zm-6.106,0H10.346a14.455,14.455,0,0,1,2.379-4.532A14.456,14.456,0,0,1,15.1,8.474ZM11.29,3.54a15.546,15.546,0,0,0-2.4,4.934H4.484A9.415,9.415,0,0,1,11.29,3.54ZM8.561,9.873a16.1,16.1,0,0,0-.017,5.861l-4.671.035A9.049,9.049,0,0,1,3.4,12.848a9.3,9.3,0,0,1,.49-2.974Z",
    fill: "#1dbbbe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.9168920d9d0faf8d7eb249b96bed244f.svg";
export { ForwardRef as ReactComponent };